<script>
    import PageLoading from "../../../../Components/Common/PageLoading.svelte";
    import {
        PatientQuoteEmailTemplatesTable as EmailTemplates,
        PatientQuoteSmsTemplatesTable as SmsTemplates,
    } from "./components/index.svelte";

    export let patientEncounterDetails = {},
        isLoading = false,
        emailNotifications = {},
        smsNotifications = {},
        patientDetails = {},
        doctorDetails = {},
        reloadCommunication = () => {};
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <div class="relative flex-1">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
            <EmailTemplates
                {patientEncounterDetails}
                {emailNotifications}
                {reloadCommunication}
            />

            <SmsTemplates
                {patientEncounterDetails}
                {smsNotifications}
                {patientDetails}
                {doctorDetails}
                {reloadCommunication}
            />
        </div>
    </div>
{/if}
